import { render } from "./EmployersForm.vue?vue&type=template&id=60cab559"
import script from "./EmployersForm.vue?vue&type=script&lang=js"
export * from "./EmployersForm.vue?vue&type=script&lang=js"
script.render = render

export default script